import _isString from 'lodash/isString';
import _includes from 'lodash/includes';
import _isObject from 'lodash/isObject';
import _result from 'lodash/result';

export const requiredField = {
  computed: {
    required() {
      return (
        (_isString(this.validation) && _includes(this.validation, 'required'))
        ||
        (_isObject(this.validation) && _result(this.validation, 'required', false))
      );
    },
  },
};
